import { createSlice } from "@reduxjs/toolkit"

const slice = createSlice({
  name: "company",
  initialState: {
    companyList: [],
    companyListLoading: true,
    companyListError: false,
    sectorList: [],
    sectorListLoading: true,
    sectorListError: false,
    industryList: [],
    industryListLoading: true,
    industryListError: false,
  },
  reducers: {
    setCompanyList: (state, action) => {
      state.companyList = action.payload
    },
    setCompanyListLoading: (state, action) => {
      state.companyListLoading = action.payload
    },
    setCompanyListError: (state, action) => {
      state.companyListError = action.payload
    },
    setSectorList: (state, action) => {
      state.sectorList = action.payload
    },
    setSectorListLoading: (state, action) => {
      state.sectorListLoading = action.payload
    },
    setSectorListError: (state, action) => {
      state.sectorListError = action.payload
    },
    setIndustryList: (state, action) => {
      state.industryList = action.payload
    },
    setIndustryListLoading: (state, action) => {
      state.industryListLoading = action.payload
    },
    setIndustryListError: (state, action) => {
      state.industryListError = action.payload
    },
  },
})

export const {
  setCompanyList,
  setCompanyListLoading,
  setCompanyListError,
  setSectorList,
  setSectorListLoading,
  setSectorListError,
  setIndustryList,
  setIndustryListLoading,
  setIndustryListError,
} = slice.actions

export default slice.reducer
